import { buildSseUrl } from '~/lib/sse/buildSseUrl'

export { buildSseUrl }

export function getSseUrl(): string {
    const config = useRuntimeConfig()
    return buildSseUrl(String(config.public.baseURL ?? ''))
}
